export default {
    fsmRoute_eta_route_etalink: "Enlace ETA",
    fsmRoute_eta_route_etalinkInfo: "Al activar esta función, se enviará un enlace a los contactos elegidos para que puedan seguir la ruta según su duración.",
    fsmRoute_eta_route_sharecamera: "Compartir instantáneas de la cámara (si se dispone de ella)",
    fsmRoute_eta_route_sharecamerainfo: "Esta opción permite mostrar las cámaras del vehículo al usuario que realiza el seguimiento desde el enlace público.",
    fsmRoute_eta_route_recipients: "Destinatarios",
    fsmRoute_eta_route_recipients_chose: "Elegir método de contacto:",
    fsmRoute_eta_route_recipients_notes: "Notas ETA",
    fsmRoute_eta_route_recipients_notesinfo: "Ingrese información adicional"
};